/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-07-13
 * @brief EHP 시험성적서 컴포넌트
 *
 ********************************************************************/
import React, { useState } from "react";
// recoil && state
import { useRecoilValue } from "recoil";
import { curSpgTreeState, } from '../../recoil/assessmentState';
//
import { useTrans } from "../../utils/langs/useTrans";
//
import $ from "jquery";
//
import * as CUTIL from "../../utils/commUtils";
import clog from "../../utils/logUtils";
import ItemReportView from "./reportlist/ItemReportView";
/**
 * @brief EHP 시험성적서 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function CheckReportMain(props) {
    const curTreeData = useRecoilValue(curSpgTreeState);
    //
    const t = useTrans();
    const selectedSpg = curTreeData;
    //   clog("Spg")
    // clog(selectedSpg);
    //모바일 트리토글 버튼 액션
    function treeToggleOnClick(e) {
        e.preventDefault();
        //모바일 트리토글 버튼 액션 트리메뉴 open 
        $(".treebar__toggleBtn").parent(".container").children(".treebar").addClass("active");
        $(".treebar__toggleBtn").parent(".container").children(".content").addClass("w100p");
        clog("click");
        //모바일 트리토글 버튼 액션 트리메뉴 shut
        $(".treebar.active .btn-tree").on("click", function () {
            $(".treebar").removeClass("active");
            $(".treebar.active .btn-tree").hide();
            //트리메뉴 토글 사이즈 최소범위       
            var mql = window.matchMedia("screen and (min-width: 768px)");
            if (mql.matches) {
                $(".box.treebar.close .btn-tree, .box.treebar .btn-tree").css({ display: "flex" });
            }
            else {
                $(".box.treebar.close .btn-tree, .box.treebar .btn-tree").css({ display: "" });
            }
        });
    }
    ;
    /*
    // 팝업창 select 콤보박스 리스트 활성화
    document.addEventListener("click", function (e) {
      //e.preventDefault();
      const targetElement = e.target as unknown as HTMLElement;
      const isSelect = targetElement.classList.contains("select") || targetElement.closest(".select");
      if (isSelect) {
        return;
      }
      const allSelectBoxElements = document.querySelectorAll(".select");
      allSelectBoxElements.forEach((boxElement) => {
        boxElement.classList.remove("active");
      });
    });
    */
    function checkTempSave(cItem, nItem) {
        var ret = false;
        if (!CUTIL.isnull(cItem)) {
            if (cItem != nItem) {
                ret = confirm("needed temp save");
                //ret = true;
            }
        }
        return ret;
    }
    function handleTreeData(val) {
    }
    const [treeOpen, setTreeOpen] = useState(false);
    const [resultOpen, setResultOpen] = useState(false);
    function handleTreeOpen(isTree) {
        clog("IN REPORTMAIN : handleTreeOpen : " + isTree);
        if (isTree) { // 결과창이 열리면
            setResultOpen(false); // <- isClose
        }
        setTreeOpen(isTree);
    }
    let isSpgSelect = (curTreeData.spg.spgId < 0) ? false : true;
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: "container filereports testrecord", style: { "cursor": "default" } },
            React.createElement("section", { className: "content" }, React.createElement(ItemReportView, { curTreeData: curTreeData })))));
}
export default CheckReportMain;
